import z from 'zod';
import { ProgressStatusDtoSchema } from '../progress-statuses/progress-statuses.schema';

export const PlayerDtoSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  level: z.number(),
  totalXp: z.number(),
  currentLevelXpRequired: z.number(),
  nextLevelXpRequired: z.number().nullish(),
  progressStatus: ProgressStatusDtoSchema.nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
}).describe('PlayerDto');

export const PlayerStatusUpContextSchema = z.object({
  userId: z.string(),
  previousStatusId: z.string().nullable(),
  previousStatusName: z.string().nullable(),
  currentStatusId: z.string(),
  currentStatusName: z.string().nullable(),
});

export const PlayerLevelUpContextSchema = z.object({
  userId: z.string(),
  previousLevel: z.number(),
  currentLevel: z.number(),
});

export const PlayerQuestCompletedContextSchema = z.object({
  userId: z.string(),
  userQuestId: z.string(),
  questId: z.string(),
  name: z.string().nullable(),
  slot: z.number(),
  level: z.number(),
  recurrenceType: z.string(),
  xpAmount: z.number(),
  completedAt: z.string(),
});

export const PlayerXpEarnedContextSchema = PlayerDtoSchema.partial();

export type PlayerDto = z.infer<typeof PlayerDtoSchema>;
export type PlayerStatusUpContext = z.infer<typeof PlayerStatusUpContextSchema>;
export type PlayerLevelUpContext = z.infer<typeof PlayerLevelUpContextSchema>;
export type PlayerXpEarnedContext = z.infer<typeof PlayerXpEarnedContextSchema>;
export type PlayerQuestCompletedContext = z.infer<typeof PlayerQuestCompletedContextSchema>;
